/**
 * Clé de traduction du message montré à l'utilisateur pour un échec d'API
 * (#66 : les écrans affichaient « PUT /projects/p1 → 403 » tel quel).
 * Le code renvoyé par kronos-api (`{ error }`) prime ; à défaut, le statut.
 * Statut 0 = la requête n'est jamais partie (réseau).
 */
const BY_CODE: Record<string, string> = {
  rate_limited: 'rateLimited',
  no_account: 'noAccount',
  invalid_payload: 'invalid',
  invalid_query: 'invalid',
};

export function apiErrorKey(status: number, code?: string): string {
  const byCode = code ? BY_CODE[code] : undefined;
  if (byCode) return `errors.api.${byCode}`;
  if (status === 0) return 'errors.api.network';
  if (status === 401) return 'errors.api.session';
  if (status === 403) return 'errors.api.forbidden';
  if (status === 404) return 'errors.api.notFound';
  if (status === 422) return 'errors.api.invalid';
  if (status === 429) return 'errors.api.rateLimited';
  if (status >= 500) return 'errors.api.server';
  return 'errors.api.generic';
}
